<template>
  <div class="home-box">
    <PageTitle :title="'Create Invoice'" class="py-5"></PageTitle>
    <v-row align="center">
      <v-overlay :value="vuexloading" :opacity="1" :color="'#FFFFFF'">
        <v-progress-circular color="#FFB300" indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <div class="col-md-12 home-tabs-body">
        <InvoiceCreateForm :proploading="loading"></InvoiceCreateForm>
      </div>
    </v-row>
  </div>
</template>

<script>
import InvoiceCreateForm from "@/components/invoices/InvoiceCreateForm";
import PageTitle from "@/components/shared/PageTitle";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

export default {
name: "InvoiceCreate",
components: {
  PageTitle,
  InvoiceCreateForm
},

data: function () {
  return {
    role: localStorage.getItem('role') || null,
    errors : null,
    loading : false,
  };
},
computed: {
  ...mapGetters({
    vuexloading: "loading",
    profile: "profile",
    hasPermission: "hasPermission",
  }),

},
mounted() {
  this.$store.dispatch("auth/getProfile");
  this.$store.dispatch("settings/getCompanySettings");
},

methods: {
},

watch: {
}
};

</script>
